
<section class="main-section">
    <section class="border-0 h-100 w-100 bg-transparent">
        <div class="text-center">

            <!-- main panel -->
            <div class="card h-100 shadow">
                <div class="card-body">

                    <h2 class="mb-3 d-none d-lg-block">{{ 'Prehľady' | translate }}</h2>

                    <app-zapisny-list-selector></app-zapisny-list-selector>

                    <!-- mobile -->

                    <div class="d-block d-md-none">

  <mat-card class="card shadow-sm m-3">
    <mat-card-header>
      <mat-card-title><span i18n>Predmety</span></mat-card-title>
    </mat-card-header>
    <mat-card-content class="w-100">
      <table class="table table-striped">
        <thead><tr><th scope="col"></th></tr></thead>
        <tbody>
        <tr>
          <td>
            <span i18n>Zapísané</span>
            <div>{{pocetZapisane}} = ({{pocetZapisaneA}}A + {{pocetZapisaneB}}B + {{pocetZapisaneC}}C<span *ngIf="pocetZapisaneIne > 0"> + {{pocetZapisaneIne}}Ine</span>)</div>
          </td>
        </tr>
        <tr>
          <td>
            <span i18n>Absolvované</span>
            <div>{{pocetAbsolvovane}} = ({{pocetAbsolvovaneA}}A + {{pocetAbsolvovaneB}}B + {{pocetAbsolvovaneC}}C<span *ngIf="pocetZapisaneIne > 0"> + {{pocetAbsolvovaneIne}}Ine</span>)</div>
          </td>
        </tr>
        <tr>
          <td>
            <span i18n>Neabsolvované</span>:
            <div>{{pocetZapisane-pocetAbsolvovane}} = ({{pocetZapisaneA-pocetAbsolvovaneA}}A + {{pocetZapisaneB-pocetAbsolvovaneB}}B + {{pocetZapisaneC-pocetAbsolvovaneC}}C<span *ngIf="pocetZapisaneIne > 0"> + {{pocetZapisaneIne-pocetAbsolvovaneIne}}Ine</span>)</div>
          </td>
        </tr>
        </tbody>
      </table>
    </mat-card-content>
  </mat-card>

  <mat-card class="card shadow-sm m-3">
    <mat-card-header>
      <mat-card-title><span i18n>Kredity</span></mat-card-title>
    </mat-card-header>
    <mat-card-content class="w-100">
      <table class="table table-striped">
        <thead><tr><th scope="col"></th></tr></thead>
        <tbody>
        <tr>
          <td>
            <span i18n>Zapísané</span>
            <div>{{kredityZapisane}} = ({{kredityZapisaneA}}A + {{kredityZapisaneB}}B + {{kredityZapisaneC}}C<span *ngIf="kredityZapisaneIne > 0"> + {{kredityZapisaneIne}}Ine</span>)</div>
          </td>
        </tr>
        <tr>
          <td>
            <span i18n>Absolvované</span>
            <div>{{kredityAbsolvovane}} = ({{kredityAbsolvovaneA}}A + {{kredityAbsolvovaneB}}B + {{kredityAbsolvovaneC}}C<span *ngIf="kredityZapisaneIne > 0"> + {{pocetAbsolvovaneIne}}Ine</span>)</div>
          </td>
        </tr>
        <tr>
          <td>
            <span i18n>Neabsolvované</span>
            <div>{{kredityZapisane-kredityAbsolvovane}} = ({{kredityZapisaneA-kredityAbsolvovaneA}}A + {{kredityZapisaneB-kredityAbsolvovaneB}}B + {{kredityZapisaneC-kredityAbsolvovaneC}}C<span *ngIf="kredityZapisaneIne > 0"> + {{kredityZapisaneIne-kredityAbsolvovaneIne}}Ine</span>)</div>
          </td>
        </tr>
        <tr *ngIf="uznane > 0">
          <td><span i18n>Uznané</span>: {{uznane}}</td>
        </tr>
        </tbody>
      </table>
    </mat-card-content>
  </mat-card>

  <mat-card class="card shadow-sm m-3">
    <mat-card-header>
      <mat-card-title><span i18n>Vážený priemer</span></mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <table class="table table-striped">
        <thead><tr><th scope="col"></th></tr></thead>
        <tbody>
        <tr>
          <td><span i18n>Všetky predmety</span></td>
          <td>{{priemery.priemerVsetkych}}</td>
        </tr>
        <tr>
          <td><span i18n>Hodnoté predmety</span></td>
          <td>{{priemery.priemerHodnotenych}}</td>
        </tr>
        <tr>
          <td><span i18n>Aj s uznanými hodnoteniami</span></td>
          <td>{{priemery.priemerHodnotenychAjUznanych}}</td>
        </tr>
        <tr>
          <td><span i18n>Štátna skúška</span></td>
          <td>{{priemery.priemerStatnicovych}}</td>
        </tr>
        </tbody>
      </table>
    </mat-card-content>

  </mat-card>

</div>

                    <!-- desktop -->

                    <div class="d-none d-md-flex mt-5 mb-5 flex-row justify-content-center pl-1 pr-1">

                      <div class="row text-start">
                        <div class="col">
                          <mat-card class="card shadow-sm m-3">
                        <mat-card-header>
                          <mat-card-title>
                            <span i18n>Predmety</span>
                          </mat-card-title>
                        </mat-card-header>
                        <mat-card-content class="w-100">
                          <table class="table mt-5 table-striped">
                            <thead>
                            <tr>
                              <th scope="col"></th>
                              <th scope="col"><span i18n>Spolu</span></th>
                              <th scope="col"><span i18n>A</span></th>
                              <th scope="col"><span i18n>B</span></th>
                              <th scope="col"><span i18n>C</span></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td><span i18n>Zapísané</span></td>
                              <td>{{pocetZapisane}}</td>
                              <td>{{pocetZapisaneA}}</td>
                              <td>{{pocetZapisaneB}}</td>
                              <td>{{pocetZapisaneC}}</td>
                            </tr>
                            <tr>
                              <td><span i18n>Absolvované</span></td>
                              <td>{{pocetAbsolvovane}}</td>
                              <td>{{pocetAbsolvovaneA}}</td>
                              <td>{{pocetAbsolvovaneB}}</td>
                              <td>{{pocetAbsolvovaneC}}</td>
                            </tr>
                            <tr>
                              <td><span i18n>Neabsolvované</span></td>
                              <td>{{pocetZapisane-pocetAbsolvovane}}</td>
                              <td>{{pocetZapisaneA-pocetAbsolvovaneA}}</td>
                              <td>{{pocetZapisaneB-pocetAbsolvovaneB}}</td>
                              <td>{{pocetZapisaneC-pocetAbsolvovaneC}}</td>
                            </tr>
                            </tbody>
                          </table>
                        </mat-card-content>
                      </mat-card>
                        </div>
                        <div class="col">
                          <mat-card class="card shadow-sm m-3">
                        <mat-card-header>
                          <mat-card-title>
                            <span i18n>Kredity</span>
                          </mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                          <table class="table mt-5 table-striped">
                            <thead>
                            <tr>
                              <th scope="col"></th>
                              <th scope="col"><span i18n>Spolu</span></th>
                              <th scope="col"><span i18n>A</span></th>
                              <th scope="col"><span i18n>B</span></th>
                              <th scope="col"><span i18n>C</span></th>
                              <th *ngIf="kredityZapisaneIne > 0" scope="col"><span i18n>Ine</span></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td><span i18n>Zapísané</span></td>
                              <td>{{kredityZapisane}}</td>
                              <td>{{kredityZapisaneA}}</td>
                              <td>{{kredityZapisaneB}}</td>
                              <td>{{kredityZapisaneC}}</td>
                              <td *ngIf="kredityZapisaneIne > 0">{{kredityZapisaneIne}}</td>
                            </tr>
                            <tr>
                              <td><span i18n>Absolvované</span></td>
                              <td>{{kredityAbsolvovane}}</td>
                              <td>{{kredityAbsolvovaneA}}</td>
                              <td>{{kredityAbsolvovaneB}}</td>
                              <td>{{kredityAbsolvovaneC}}</td>
                              <td *ngIf="kredityZapisaneIne > 0">{{pocetAbsolvovaneIne}}</td>
                            </tr>
                            <tr>
                              <td><span i18n>Neabsolvované</span></td>
                              <td>{{kredityZapisane-kredityAbsolvovane}}</td>
                              <td>{{kredityZapisaneA-kredityAbsolvovaneA}}</td>
                              <td>{{kredityZapisaneB-kredityAbsolvovaneB}}</td>
                              <td>{{kredityZapisaneC-kredityAbsolvovaneC}}</td>
                              <td *ngIf="kredityZapisaneIne > 0">{{kredityZapisaneIne-kredityAbsolvovaneIne}}</td>
                            </tr>
                            <tr *ngIf="uznane > 0">
                              <td><span i18n>Uznané</span></td>
                              <td>{{uznane}}</td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                            </tbody>
                          </table>
                        </mat-card-content>
                      </mat-card>
                        </div>
                        <div class="col">
                          <mat-card class="card shadow-sm m-3">
                        <mat-card-header>
                          <mat-card-title>
                            <span i18n>Vážený priemer</span>
                          </mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                          <table class="table mt-5 table-striped">
                            <tbody>
                            <tr>
                              <td><span i18n>všetky predmety</span></td>
                              <td>{{priemery.priemerVsetkych}}</td>
                            </tr>
                            <tr>
                              <td><span i18n>hodnoté predmety</span></td>
                              <td>{{priemery.priemerHodnotenych}}</td>
                            </tr>
                            <tr>
                              <td><span i18n>aj s uznanými hodnoteniami</span></td>
                              <td>{{priemery.priemerHodnotenychAjUznanych}}</td>
                            </tr>
                            <tr>
                              <td><span i18n>štátna skúška</span></td>
                              <td>{{priemery.priemerStatnicovych}}</td>
                            </tr>
                            </tbody>
                          </table>
                        </mat-card-content>

                      </mat-card>
                        </div>
                      </div>

                    </div>

                </div>
            </div>

        </div>
    </section>
</section>
